<template>
    <div id="userList">
        <div class="searchContent" id="search">
            <div class="p_select search_day_list">
                <div class="search_label">查询日期</div>
                <div @mouseover="onMouseOver('start')" @mouseleave="onMouseleave('start')">
                    <el-date-picker
                            @change="queryCheckEfficiencyDaily"
                            v-model="checkDay"
                            type="date"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerDayOptions"
                            prefix-icon="''"
                            class="datepicker"
                            placeholder="选择日期">
                    </el-date-picker>
                    <i class="el-icon-date" ref="iconDateStart"></i>
                </div>
            </div>
            <div class="p_select">
                <el-button class="search_btn" @click="queryCheckEfficiencyDaily"  >查询</el-button>
                <el-button class="add_btn" @click="exportTable('#checkEfficiencyDaily')">导出</el-button>
            </div>
        </div>
        <div class="table">
            <el-table id="checkEfficiencyDaily" border :data="checkEfficiencyDaily" :height=winHeight ref="table_3" :header-cell-style="tableHeaderColor" :span-method="objectSpanMethod" >
                <el-table-column prop="carNumber" label="车牌号" align="left"></el-table-column>
                <el-table-column prop="dossierId" label="档案ID" align="left"></el-table-column>
                <el-table-column prop="workerName" label="技师" align="left"></el-table-column>
                <el-table-column prop="positionName" label="部位名称" align="left"></el-table-column>
                <el-table-column prop="startTime" label="检测开始时间" align="left"></el-table-column>
                <el-table-column prop="endTime" label="检测结束时间" align="left"></el-table-column>
                <el-table-column prop="checkTime" label="统计用时" align="left"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
  import net from "../../assets/js/public";
  import XLSX from "xlsx";
  import FileSaver from "file-saver";
  import moment from "moment";
  export default {
    name: "salesDealSummany",
    data(){
      return {
        orgId: "",
        checkDay: "",
        pickerDayOptions: { // 按天 当天、当月可选
          disabledDate(time) {
            return time.getTime() > Date.now() + 1 * 24 * 60 * 60 * 1000;
          }
        },
        checkEfficiencyDaily:[],
        winHeight:'200',


      }
    },
    created() {
      let signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
      if (signInfo.orgId > 0) {
        this.orgId = signInfo.orgId;
      }
      let obj = new Date();
      let month = obj.getMonth() + 1;
      let day = obj.getDate();
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;
      this.checkDay = obj.getFullYear() + "-" + month + "-" + day;
      this.queryCheckEfficiencyDaily();

    },
    methods: {
      onMouseOver(item) {
        this.$refs.iconDateStart.style.display = "none";
      },
      onMouseleave(item) {
        this.$refs.iconDateStart.style.display = "block";
      },
      // 表头样式
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        return "background-color:#F3F7FB; color: #364556; text-align: left;font-size: 14px;height: 48px;font-weight: 500;font-family: 'PingFang SC';";
      },
      objectSpanMethod({ row, column, rowIndex, columnIndex }){
        if (columnIndex === 0) {
          const _row = (this.flitterData(this.checkEfficiencyDaily ).one)[rowIndex];
          const _col = _row > 0 ? 1 : 0;
          return {
            rowspan: _row,
            colspan: _col
          };
        }
        if (columnIndex === 1) {
          const _row = (this.flitterData(this.checkEfficiencyDaily ).two)[rowIndex];
          const _col = _row > 0 ? 1 : 0;
          return {
            rowspan: _row,
            colspan: _col
          };
        }
      },
      flitterData(arr) {
        let spanOneArr = [],
          spanTwoArr = [],
          concatOne = 0,
          concatTwo = 0;
        arr.forEach((item, index) => {
          if (index === 0) {
            spanOneArr.push(1);
            spanTwoArr.push(1);
          } else {
            if (item.carNumber === arr[index - 1].carNumber) { //第一列需合并相同内容的判断条件
              spanOneArr[concatOne] += 1;
              spanOneArr.push(0);
              spanTwoArr[concatTwo] += 1;
              spanTwoArr.push(0);
            } else {
              spanOneArr.push(1);
              concatOne = index;
              spanTwoArr.push(1);
              concatTwo = index;
            }
          }
        })
        return {
          one: spanOneArr,
          two: spanTwoArr,
        }
      },

      queryCheckEfficiencyDaily(){
        if(this.checkDay == '' || this.checkDay == null){
          net.message(this, '请选择需要查询的站点和时间', "warning");
          return
        }
        const params = {
          orgId: this.orgId,
          checkDay: this.checkDay
        };
        net.request("manage/workerEfficiency/queryCheckEfficiencyDaily", "post", null, params).then(res => {
          if (res.code === 0) {
            let data = res.data

            let checkEfficiencyDaily = []
            for(let item in data){
              let obj = {};
              data[item].forEach((i, index) => {
                obj[index] = i;
              });
              for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                  checkEfficiencyDaily.push(obj[key])
                }
              }
            }

            checkEfficiencyDaily.forEach(item => {
              item.checkTime = item.startTime && item.endTime ?  this.calcDateDiff(item.startTime*1, item.endTime*1) : '-'

              item.startTime = item.startTime ? moment(item.startTime*1).format('YYYY-MM-DD HH:mm:ss') :'-'
              item.endTime = item.endTime ? moment(item.endTime*1).format('YYYY-MM-DD HH:mm:ss') :'-'
            })
            this.checkEfficiencyDaily = checkEfficiencyDaily

            const windiwHight = document.documentElement.clientHeight || document.body.clientHeight; // 可视屏幕高度
            this.winHeight = windiwHight - 168;


          } else {
            net.message(this, "获取数据失败", "warning");
          }
        });
      },


      //计算两个时间之间的时间差 多少天时分秒
      calcDateDiff(date1, date2) {
        const difference = new Date(date2) - new Date(date1); //时间差的毫秒数
        //计算出相差天数
        const days = Math.floor(difference / (24 * 3600 * 1000));
        //计算出小时数

        const leave1 = difference % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
        const hours = Math.floor(leave1 / (3600 * 1000));
        //计算相差分钟数
        const leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
        const minutes = Math.floor(leave2 / (60 * 1000));

        //计算相差秒数

        const leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
        const seconds = Math.round(leave3 / 1000);
        if(days){
          return days + "天 " +hours + "小时 " + minutes + "分 " + seconds + "秒";
        }else if (hours){
          return hours + "小时 " + minutes + "分 " + seconds + "秒";
        }else if(minutes){
          return minutes + "分 " + seconds + "秒";
        }else if(seconds) {
          return seconds + "秒";
        }
      },

      // 导出数据
      exportTable(elTableId) {
        var wb = XLSX.utils.table_to_book(document.querySelector(elTableId));
        var wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array"
        });
        try {
          FileSaver.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            "技师-检测效率-日报.xlsx"
          );
        } catch (e) {
          if (typeof console !== "undefined") console.log(e, wbout);
        }
        return wbout;
      },
    },
    mounted() {
      window.addEventListener('keyup',this.handleKeyup)
    },
    beforeDestroy() {
      window.removeEventListener('keyup',this.handleKeyup)
    }
  };
</script>

<style lang="less" scoped>
    #userList {
        display: flex;
        flex-direction: column;
        margin: 24px 0 0 24px;
        background: #fff;
        padding-left: 12px;
        padding-bottom: 10px;

        .searchContent {
            background: #fff;
            padding-top: 12px;
            margin-bottom: 12px;
            .p_select {
                display: flex;
                margin-right: 12px;
                font-size: 12px;
                float: left;
                .search_label{
                    font-family: 'PingFang SC';
                    font-style: normal;
                    margin-right: 12px;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 40px;
                    color: #787E86;
                    white-space:nowrap
                }

                .el-input , .el-select{
                    width: 160px;
                }
            }
            .search_btn {
                height: 38px;
                background: #2B54FC;
                box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                border-radius: 4px;
                color: #FFFFFF;
                font-size: 14px;
            }
            .add_btn {
                height: 36px;
                background: rgba(148, 170, 204, 0.08);
                border: 1px solid #2B54FC;
                border-radius: 4px;
                font-size: 14px;
                color: #2B54FC;
            }

            .option_box{
                margin-bottom: 24px;
                display: flex;
                .option_item {
                    width: 200px;
                    height: 36px;
                    margin-right: 12px;
                    background: #FFFFFF;
                    box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                    border-radius: 4px;
                    text-align: center;
                    line-height: 36px;
                    font-weight: 400;
                    font-size: 14px;
                    text-align: center;
                    color: #364556;
                }
                .option_active {
                    background: #2B54FC;
                    color: #FFFFFF;
                    font-weight: 500;
                }
            }
            .option_item_box{
                margin-bottom: 24px;
                display: flex;
                .item_ {
                    height: 36px;
                    margin-right: 12px;
                    background: #FFFFFF;
                    box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                    border-radius: 4px;

                    line-height: 36px;
                    padding: 0 24px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #364556;
                }
                .item_active {
                    background: #2B54FC;
                    color: #FFFFFF;
                    font-weight: 500;
                }
            }

        }
        .table {
            padding-right: 12px;
        }
        .list_content {
            background: #fff;
            padding-left: 24px;
            padding-right: 24px;
        }
    }
</style>
